import { useMemo } from 'react';
import useFetch from 'framework-asset-preview-lib/internal/shared/hooks/useFetch';
import { fetchAssociationsFromCRM } from 'framework-asset-preview-lib/internal/shared/api/associations';
import useCrmAssetAssociations from './useCrmAssetAssociations';
export default function useFetchAssociationsFromCRM({
  crmObject,
  crmObjectTypeDefinitionsForPortal
}) {
  const crmAssociations = useCrmAssetAssociations();
  const fetchAssociationProps = useMemo(() => ({
    fetcher: () => fetchAssociationsFromCRM(crmObject.objectTypeId, crmObjectTypeDefinitionsForPortal || [], crmAssociations),
    skip: Boolean(!crmObjectTypeDefinitionsForPortal || crmObjectTypeDefinitionsForPortal.length === 0)
  }), [crmAssociations, crmObject.objectTypeId, crmObjectTypeDefinitionsForPortal]);
  return useFetch(fetchAssociationProps);
}